import { useState, useRef, useEffect } from 'react'

import { elementInViewport } from '../utils/styling/elementInViewport'
import { useScrollPosition } from './useScrollPosition'

const useShouldAnimate = (runMultiple = false) => {
  const [isVisible, setIsVisible] = useState(false)
  const [hasAppeared, setHasAppeared] = useState(false)
  const ref = useRef(null)

  const { scrollY } = useScrollPosition()

  useEffect(() => {
    if (ref?.current) {
      if (elementInViewport(ref.current)) {
        if (!isVisible) {
          setIsVisible(true)
          setHasAppeared(true)
        }
      }
      !elementInViewport(ref.current) && isVisible && setIsVisible(false)
    }
  }, [isVisible, scrollY])

  return {
    ref,
    shouldAnimate: runMultiple ? isVisible : isVisible || hasAppeared,
  }
}

export const useShouldAnimateOnMount = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
    return () => {
      setIsVisible(false)
    }
  }, [])

  return {
    shouldAnimate: isVisible,
  }
}

export default useShouldAnimate
